<template>
    <div class="temp">
        <dv-scroll-board ref="workerStatusScroll" :config="workerStatusScrollConfig" style="height: 90%"/>
    </div>
</template>

<script>
import {_pxGenerator, getOrDefault} from "../../../../LayoutMaps/maps/MapFunction";
import EmCommonApi from "@/mixin/em/common/api";
import {_getWorkshopCode} from "./CodeToName";

export default {
    name: "WorkerStatusScroll",
    props: {
        code: Number
    },
    mixins: [EmCommonApi],
    data() {
        return {
            workerStatusScrollConfig: {
                header: ['工位', '工位状态', '人员', '人员状态'],
                data: [],
                index: false,
                align: ['center'],
                rowNum: 8,
                headerBGC: '#1981f6',
                headerHeight: _pxGenerator(0.4),
                oddRowBGC: 'rgba(0, 44, 81, 0.8)',
                evenRowBGC: 'rgba(10, 29, 50, 0.8)',
                hoverPause: false
            },
            fresh: {}
        }
    },
    mounted() {
        this.getData()
        this.fresh = setInterval(() => {
            this.getData()
        }, 30000)
    },
    beforeDestroy() {
        clearInterval(this.fresh);
    },
    methods: {
        getData() {
            let self = this;
            const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesMstLocation")}/sithMesMstWorkshop/kpi/workerStatus`
            this.$_emApiMixin_post(_api, {
                code: _getWorkshopCode(this.code)
            }, false).then(value => {
                let arr = value.data;
                let result = [];
                for (let item of arr) {
                    let row = [];
                    row.push(getOrDefault('workCenter', item, ''));
                    let status = getOrDefault('workCenterStatus', item, 1);
                    row.push(status === 1 ? '正常' : status === 2 ? '报警' : '停机');
                    row.push(getOrDefault('worker', item, ''));
                    row.push(getOrDefault('workerStatus', item, '在岗'));
                    result.push(row)
                }
                self.workerStatusScrollConfig.data = result;
                self.$refs.workerStatusScroll.updateRows(result);
                this.resize();
            })
        },
        resize() {
            let resize = setInterval(() => {
                let scroll = this.$refs.workerStatusScroll;
                if (scroll !== undefined) {
                    scroll.calcHeights();
                }
            }, 1000);
            setTimeout(() => clearInterval(resize), 5000);
        }
    }
}
</script>

<style scoped>
.temp {
    width: 100%;
    height: 100%;
}

.temp >>> .header {
    font-size: 1rem;
}

.temp >>> .rows .row-item {
    font-size: 1rem;
}
</style>